import { BRAND_LOGO } from "../constants/membershipCard"
import FleetAdviseLogo from "../assets/images/fleetcore-short.svg"

const FleetCard = ({}) => {
  return (
      <div className="fleet-card">
        <div className="fleet-card__header">
          <div className="fleet-card__label">CarAdvise National Fleet Account</div>
          <div className="fleet-card__icon-wrapper">
            <img
              className="fleet-card__icon"
              src={FleetAdviseLogo}
              alt="Fleet Icon"
            />
          </div>
        </div>

        <div className="fleet-card__logos">
          {BRAND_LOGO.map((logo, index) => (
            <img key={index} src={logo} alt={`Logo ${index}`} className="fleet-card__logo" />
          ))}
        </div>

        <p className="fleet-card__stores">Over 25,000 stores nationwide</p>

        <div className="fleet-card__instructions">
          <h3>Shop Instructions</h3>
          <p>
            *Process as <strong>CarAdvise National Fleet Account</strong> through{' '}
            <strong>Auto Integrate</strong>, or call CarAdvise at <strong>(312) 779-1549</strong> for
            approval and billing.
          </p>
        </div>
      </div>
    );
}


export default FleetCard
